module.exports = __webpack_public_path__ + "img/send-bitcoin-sm.a69bbe0c.svg";